export const warningDiscardUnmanagedInstrumentDescription =
  '廃棄した機器はもとに戻すことや編集ができなくなります。本当に廃棄しますか？';
export const warningExcludeManagementInstrumentDescription =
  '管理対象外にする場合、今後の予約が全てキャンセルされます。管理対象外にしますか？';
